class AutoScoutMessageTemplate {
  ready() {
    $(document).ready(function() {
      if (window.location.pathname.includes('/edit/message_template')) {
        let anchor = window.location.hash
        if (!anchor) anchor = '#send-ja'
        let tabId = anchor.split('-')[0]
        $('ul.nav-pills').find(`a[href="${tabId}"]`).tab('show')
        if (['#send-ja', '#resend-ja'].includes(anchor)) {
          $('html, body').scrollTop(0)
        } else {
          $('html, body').animate({ scrollTop: $(anchor).offset().top }, 1000)
        }
      }
      if ($('input.js-only-resend-error').val() === 'true')
        $('ul.nav-pills').find(`a[href="#resend"]`).tab('show')
    })
  }

  onChangeTemplateTypes(target, lang, category = 'send') {
    let type = $(target).val()
    let send = category == 'send'
    let options = `<option value>${gon.views.shared.please_choose}</option>`
    let selectEle = send ? $(`#message_${lang}_message_template_id`) : $(`#message_${lang}_message_template_resend_id`)
    let bodyEle = send ? $(`#message_${lang}_mail_body`) : $(`#message_${lang}_mail_resend_body`)
    let selectTemplateEle = send ? $(`.select-${lang}-template-area`) :  $(`.select-${lang}-resend-template-area`)
    let subjectEle = send ? $(`#message_${lang}_mail_subject`) : $(`#message_${lang}_mail_resend_subject`)

    if (type === '0') {
      let templates = lang == 'ja' ? gon.ja_master_message_templates : gon.en_master_message_templates
      templates.forEach(ele => {
        options += `<option value=${ele.id}>${ele.title}</option>`
      })
      selectTemplateEle.removeClass('d-none')
    } else if (type === '1') {
      gon.company_message_templates.forEach(ele => {
        options += `<option value=${ele.id}>${ele.title}</option>`
      })
      selectTemplateEle.removeClass('d-none')
    } else {
      selectTemplateEle.addClass('d-none')
    }
    bodyEle.val('')
    subjectEle.val('')
    selectEle.html(options)
  }

  onChangeMessageTemplate(target, lang, category = 'send') {
    let id = $(target).val()
    let type = $(target).closest('td').find('input.custom-control-input:checked').val()
    let master_message_templates = lang == 'ja' ? gon.ja_master_message_templates : gon.en_master_message_templates
    let templates = type === '0' ? master_message_templates : gon.company_message_templates
    let message = templates.find((template) => template.id == parseInt(id))
    let subjectEle = category == 'send' ? $(`#message_${lang}_mail_subject`) : $(`#message_${lang}_mail_resend_subject`)
    let bodyEle = category == 'send' ? $(`#message_${lang}_mail_body`) : $(`#message_${lang}_mail_resend_body`)

    if (message) {
      if (type !== '0') subjectEle.val(message.subject)
      bodyEle.val(message.body)
    } else {
      subjectEle.val('')
      bodyEle.val('')
    }
  }

  onCloseOrRedirectWindow(path) {
    if (window.history.length === 1 || (window.opener && window.opener !== window)) {
      window.opener.location.reload(true)
      window.close()
    } else {
      window.location.replace(path)
    }

    if (window.history.length > 1) {
      let beforeWindow = window.opener;
      for (let i = 0; i < window.history.length; i++) {
        if (beforeWindow && beforeWindow.opener && beforeWindow.opener !== beforeWindow) {
          beforeWindow.opener.location.reload(true);
          beforeWindow = beforeWindow.opener;
        }
      }
    }
  }
}

export default new AutoScoutMessageTemplate()
